import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { ScrollLockContext } from 'contexts/ScrollLockContext'
import React, { useContext } from 'react'
import { createGlobalStyle } from 'styled-components'
import { isSjDomain, isKsDomain } from 'utils/domain'

const GlobalStyle: React.FC = () => {
  const [scrollLock] = useContext(ScrollLockContext)
  return (
    <React.Fragment>
      <GlobalStyleCSS scrollLock={scrollLock} />
      {isSjDomain() && <SjGlobalStyleCSS />}
      {isKsDomain() && <KsGlobalStyleCSS />}
    </React.Fragment>
  )
}
/**
 * グローバルに適用させるCSS
 */
const GlobalStyleCSS = createGlobalStyle<{ scrollLock: boolean }>`
  :root {
    /* Colors */
    /* Main */
    --color-main: ${CLIENT_SETTINGS.colors.main};
    --color-text-for-main-background: ${
      CLIENT_SETTINGS.colors.textForMainBackground
    };
    /* Main gradient */
    --color-main-gradient-start: ${CLIENT_SETTINGS.colors.mainGradientStart};
    --color-main-gradient-end: ${CLIENT_SETTINGS.colors.mainGradientEnd};
    /* Common */
    --color-text: ${CLIENT_SETTINGS.colors.text};
    --color-background: ${CLIENT_SETTINGS.colors.background};
    --color-footer: ${CLIENT_SETTINGS.colors.footer};
    --color-content-background: ${CLIENT_SETTINGS.colors.contentBackground};
    --color-border: ${CLIENT_SETTINGS.colors.border};
    --color-warning: ${CLIENT_SETTINGS.colors.warning};
    --color-error: ${CLIENT_SETTINGS.colors.error};
    --color-invalid-background: ${CLIENT_SETTINGS.colors.invalidBackground};
    /* Disabled */
    --color-disabled: ${CLIENT_SETTINGS.colors.disabled};
    --color-disabled-text: ${CLIENT_SETTINGS.colors.disabledText};
    /* Modal */
    --color-modal-background: ${CLIENT_SETTINGS.colors.modalBackground};
    --color-modal-text: ${CLIENT_SETTINGS.colors.modalText};
    /* Icon */
    --color-icon-car: ${CLIENT_SETTINGS.colors.iconCar};
    --color-icon-partner: ${CLIENT_SETTINGS.colors.iconPartner};
  }
  html, body {
    margin: 0;
    padding: 0;
    ${(props): string => (props.scrollLock ? 'overflow: hidden;' : '')}
    color: var(--color-text);
    font-family: YuGothic, "Yu Gothic Medium", "Yu Gothic", -apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Helvetica Neue", HelveticaNeue, Verdana, Meiryo, sans-serif;
    background: var(--color-background);
    border: 0
  }
  a {
    text-decoration: none;
  }
`
/**
 * SJに適用させるCSS
 */
const SjGlobalStyleCSS = createGlobalStyle`
  html, body {
    position: relative;
    min-height: 100vh;
  }
`

/**
 * 共済系に適用させるCSS
 */
const KsGlobalStyleCSS = createGlobalStyle`
  html, body {
    position: relative;
    min-height: 100vh;
  }
`
export default GlobalStyle
